const snackConst = {};
const otpRegex = /^\d{6}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
const adminImage =
  "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?size=338&ext=jpg&ga=GA1.1.2008272138.1728345600&semt=ais_hybrid";

const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

const endPoints = {
  // Authentcation
  businessAccount: "business/create",
  sendOtpBusinessAccount: "business/sendOtp",
  addDetails: "business/detail/add",
  handleLogin: "business/login",
  createBusinessBranch: "business/branch/register",
  fetchBusinessBranch: "business/branch/fetch",
  fetchAdminDetail: "admin/fetchAdminDetail",
  deleteBranch: "business/delete",
  updateBusinessBranch: "business/update",
  loginAsBusiness: "admin/business/fetch",
  verifyOtp: "user/register/verify",
  getSettings: "admin/settings/terms/fetch",

  //user
  searchClients: "user/searchApi",

  //DashBoard
  fetchDashboardData: "business/dashboard/fetch",

  // Category
  //New Flow Work
  createCategory: "branch/category/create",
  updateCategory: "branch/category/update",
  // ________________X_________________//

  fetchCategory: "branch/category/get",
  getBranchCategory: "admin/category/get",
  deleteCategory: "business/category/delete",

  //plans
  fetchSubscription: "admin/subscription/fetch",
  userSubscription: "business/subscription/create",
  fetchBusinessSubscriptionHistory: "business/subscription-history/fetch",

  //Team
  deleteTeams: "business/team/delete",
  teamSchedule: "business/shift/fetch",

  //New Flow Work

  //Team
  createTeamMember: "branch/team/create",
  updateTeamMembers: "branch/team/update",
  fetchAllTeamMembers: "branch/team/fetch",

  //Service
  createService: "branch/service/create",
  getAllServices: "branch/service/get-branch",
  getServiceDetails: "branch/service/get/detail",
  updateAllService: "branch/service/update",

  // ________________X_________________//

  deleteService: "business/service/delete",

  //Packages
  createPackage: "business/package/create",
  getAllPackages: "business/packages/fetch",
  updateAllPackage: "business/package/update",
  deletePackage: "business/package/delete",
  getSinglePackagesData: "business/package/fetch",

  //Appointments
  fetchAllEvents: "business/appointment/fetch",
  EventsDetailsById: "business/appointment/details",
  updateAppointmentById: "business/appointment/update",
  fetchAllAppointments: "business/sales/get-all",
  updateAppointmentTime: "business/updateTime",
  createAppointment: "business/appointment/create",
  createClient: "user/register/admin",

  //Reporting
  fetchAllBusinesses: "admin/all-business/fetch",

  //All Sales
  fetchAllSales: "business/sales/summary",

  //All Branches
  fetchAllBranchaesbyId: "admin/all-branches-by-business/fetch",
  fetchBusinessDetailById: "user/business/fetch",

  //Business Reports
  fetchBusinessReport: "business/all/fetch",

  //Clients Lists
  fetchClients: "business/clients/fetch",

  //AllReviews
  allReviews: "business/review/fetch",

  //Teams By service
  featchAllTeam: "user/teams/fetch",
  fetchProTeams: "user/teams/fetchProfessionalByService",

  //fetch Time
  timeslots: "business/timmings/fetch",

  //************ NEW FLOW ***************//

  //Branch
  getBranchDetails: "branch/details",
  getBranches: "branch/get",
  createBranch: "branch/create",
  updateBranch: "branch/update",

  //Roles
  businessCreateRole: "business/role/create",
  fetchBusinessRole: "business/role/get",
  updateRole: "business/role/update",

  //Business User
  createUser: "business/user/create",
  getAllUserByBusiness: "business/user/get",
  updateUser: "business/user/update",

  //Support

  support: "/contact",
};

export {
  emailRegex,
  endPoints,
  otpRegex,
  passwordRegex,
  requestType,
  snackConst,
  adminImage,
};
